import React from 'react';
import { BeyondBannerWhite } from '@/src/components/Banners/GetBeyondBanner/BeyondBannerWhite';
import BeyondImageNoSMLarge from '@/src/resources/beyond/beyond-mockup-no-sm-large.png';
import BeyondImageNoSMSmall from '@/src/resources/beyond/beyond-mockup-no-sm-small.png';
import BeyondImageNoDDNoSMLarge from '@/src/resources/beyond/beyond-mockup-no-ddsm-large.png';
import BeyondImageNoDDNoSMSmall from '@/src/resources/beyond/beyond-mockup-no-ddsm-small.png';
import BeyondImageNoDDLarge from '@/src/resources/beyond/beyond-mockup-no-dd-large.png';
import BeyondImageNoDDSmall from '@/src/resources/beyond/beyond-mockup-no-dd-small.png';
import { useAnalytics } from '@ovotech/ui-tools';
import { BEYOND_BANNER, BeyondStatusValue } from '@/src/constants/analytics';
import { useBeyondWebTestVariant } from '@/src/components/Banners/GetBeyondBanner/useBeyondWebTestVariant';
import { useBeyondAccountFlags } from '@/src/hooks/useBeyondAccountFlags/useBeyondAccountFlags';

const buildProps = (
  beyondStatus: BeyondStatusValue | undefined,
  testVariant: string | null,
) => ({
  ...(beyondStatus && { 'Beyond Status': beyondStatus }),
  ...(testVariant && { 'Test variant': testVariant }),
});

export const NoSMBanner = () => {
  const { dispatch } = useAnalytics();
  const testVariant = useBeyondWebTestVariant();
  const { beyondStatus } = useBeyondAccountFlags();

  const onAppStoreButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.NO_SM.CLICKED_APP_STORE,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  const onGooglePlayButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.NO_SM.CLICKED_GOOGLE_PLAY,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  return (
    <BeyondBannerWhite
      heading={{
        startText: 'Send readings ',
        highlightedText: 'in seconds',
      }}
      description={[
        'Log in securely with just a tap. It’s the fastest way to send readings and check your balance.',
      ]}
      largeImageSrc={BeyondImageNoSMLarge}
      smallImageSrc={BeyondImageNoSMSmall}
      onAppStoreButtonClick={onAppStoreButtonClick}
      onGooglePlayButtonClick={onGooglePlayButtonClick}
    />
  );
};

export const NoDDOrSMBanner = () => {
  const { dispatch } = useAnalytics();
  const testVariant = useBeyondWebTestVariant();
  const { beyondStatus } = useBeyondAccountFlags();

  const onAppStoreButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.NO_DD_OR_SM.CLICKED_APP_STORE,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  const onGooglePlayButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.NO_DD_OR_SM.CLICKED_GOOGLE_PLAY,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  return (
    <BeyondBannerWhite
      heading={{
        startText: 'Your energy,',
        highlightedText: ' always on hand',
      }}
      description={[
        'Get free, instant access to your account whenever you need it. Download the OVO app.',
      ]}
      largeImageSrc={BeyondImageNoDDNoSMLarge}
      smallImageSrc={BeyondImageNoDDNoSMSmall}
      onAppStoreButtonClick={onAppStoreButtonClick}
      onGooglePlayButtonClick={onGooglePlayButtonClick}
    />
  );
};

// IneligibleBanner is identical to NoDDOrSMBanner but with different tracking events
export const IneligibleBanner = () => {
  const { dispatch } = useAnalytics();
  const testVariant = useBeyondWebTestVariant();
  const { beyondStatus } = useBeyondAccountFlags();

  const onAppStoreButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.INELIGIBLE.CLICKED_APP_STORE,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  const onGooglePlayButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.INELIGIBLE.CLICKED_GOOGLE_PLAY,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  return (
    <BeyondBannerWhite
      heading={{
        startText: 'Your energy,',
        highlightedText: ' always on hand',
      }}
      description={[
        'Get free, instant access to your account whenever you need it. Download the OVO app.',
      ]}
      largeImageSrc={BeyondImageNoDDNoSMLarge}
      smallImageSrc={BeyondImageNoDDNoSMSmall}
      onAppStoreButtonClick={onAppStoreButtonClick}
      onGooglePlayButtonClick={onGooglePlayButtonClick}
    />
  );
};

// TODO: To be implemented on Rewards page
export const RewardsBanner = () => {
  const { dispatch } = useAnalytics();
  const testVariant = useBeyondWebTestVariant();
  const { beyondStatus } = useBeyondAccountFlags();

  const onAppStoreButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.REWARDS.CLICKED_APP_STORE,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  const onGooglePlayButtonClick = () => {
    dispatch({
      name: BEYOND_BANNER.REWARDS.CLICKED_GOOGLE_PLAY,
      type: 'click',
      properties: buildProps(beyondStatus, testVariant),
    });
  };

  return (
    <BeyondBannerWhite
      heading={{
        startText: 'Get the OVO app',
      }}
      description={[
        'It’s free to download. ',
        'Beyond unlocks automatically once you’re eligible.',
      ]}
      largeImageSrc={BeyondImageNoDDLarge}
      smallImageSrc={BeyondImageNoDDSmall}
      onAppStoreButtonClick={onAppStoreButtonClick}
      onGooglePlayButtonClick={onGooglePlayButtonClick}
    />
  );
};
